import parsePhoneNumber from 'libphonenumber-js'
import PhoneService from '@widgets/shared/services/phoneService'
import { TmFakeCountryCode, type TmCountryCode } from '@/services/types'

export default class LibPhoneNumberService extends PhoneService {
  public getCountryByPhone(phone: string | null): TmCountryCode | null {
    if (!phone) return null
    if (this.isFakePhoneNumber(this.getPhoneWithLeadingPlus(phone))) {
      return TmFakeCountryCode
    }
    const phoneData = this.getPhoneData(phone)
    return phoneData && phoneData.country ? phoneData.country : null
  }

  private getPhoneData(phone: string) {
    try {
      const preparePhone = this.getPhoneWithLeadingPlus(phone)
      return parsePhoneNumber(preparePhone) ?? null
    } catch (e: any) {
      // do nothing - there are mistakes like "too short number" etc
      return null
    }
  }
}

export const libPhoneNumberService = new LibPhoneNumberService()
